import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { getLogs, getStats, getDates } from '../../actions/monitoramentoActions';
import { translate } from '../../components/Translate';
import { Bar } from 'react-chartjs-2';
import DataTable from 'react-data-table-component';
import './style.css';

class Monitoramento extends Component {
    constructor(props) {
        super(props);
        if (!localStorage.getItem('bfToken')) {
            window.location.href = '/';
        }

        const today = new Date().toISOString().split('T')[0];
        this.state = {
            filters: {
                date_start: today,
                date_end: today,
                module: '',
                action: '',
                campaign_id: '',
                ip: '',
                level: '',
                search: '',
                page: 1,
                limit: 50,
            },
            expandedRow: null,
            autoRefresh: false,
            autoRefreshInterval: null,
        };

        this.columns = [
            {
                name: 'Timestamp',
                selector: 'timestamp',
                sortable: true,
                width: '170px',
                cell: row => <span className="mono-sm">{row.timestamp}</span>
            },
            {
                name: 'Level',
                selector: 'level',
                width: '90px',
                cell: row => (
                    <span className={`monitoramento-level level-${this.getLevelColor(row.level)}`}>
                        {row.level}
                    </span>
                )
            },
            {
                name: 'Action',
                selector: 'action',
                width: '140px',
                cell: row => (
                    <span className="monitoramento-level level-secondary" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '130px', display: 'inline-block' }}>
                        {row.module}/{row.action}
                    </span>
                )
            },
            {
                name: 'Campaign',
                selector: 'campaign_id',
                width: '90px',
            },
            {
                name: 'IP',
                selector: 'ip',
                width: '120px',
                cell: row => <span className="mono-sm">{row.ip || '-'}</span>
            },
            {
                name: 'Status',
                selector: 'status',
                width: '150px',
                cell: row => row.status ? (
                    <span className={`monitoramento-level level-${row.status === 'SEM_user_painel_id' ? 'danger' : 'info'}`} style={{ whiteSpace: 'nowrap', fontSize: '10px' }}>
                        {row.status}
                    </span>
                ) : '-'
            },
            {
                name: 'User Painel',
                selector: 'user_painel_id',
                width: '100px',
                cell: row => <span className="mono-sm">{row.user_painel_id || '-'}</span>
            },
            {
                name: 'Query Params',
                width: '200px',
                cell: row => this.renderParams(row.get_params)
            },
        ];
    }

    componentDidMount() {
        this.fetchData();
        this.props.getDates();
    }

    componentWillUnmount() {
        if (this.state.autoRefreshInterval) {
            clearInterval(this.state.autoRefreshInterval);
        }
    }

    fetchData = () => {
        const { filters } = this.state;
        this.props.getLogs(filters);
        this.props.getStats({
            date_start: filters.date_start,
            date_end: filters.date_end,
            module: filters.module,
            action: filters.action,
            campaign_id: filters.campaign_id,
            ip: filters.ip,
            level: filters.level,
        });
    }

    handleFilterChange = (field, value) => {
        this.setState(prev => ({
            filters: { ...prev.filters, [field]: value, page: 1 }
        }));
    }

    handleSearch = (e) => {
        e.preventDefault();
        this.fetchData();
    }

    handlePageChange = (page) => {
        this.setState(prev => ({
            filters: { ...prev.filters, page }
        }), () => {
            this.props.getLogs(this.state.filters);
        });
    }

    toggleAutoRefresh = () => {
        if (this.state.autoRefresh) {
            clearInterval(this.state.autoRefreshInterval);
            this.setState({ autoRefresh: false, autoRefreshInterval: null });
        } else {
            const interval = setInterval(() => this.fetchData(), 15000);
            this.setState({ autoRefresh: true, autoRefreshInterval: interval });
        }
    }

    getLevelColor(level) {
        switch (level) {
            case 'error': return 'danger';
            case 'warning': return 'warning';
            case 'info': return 'info';
            default: return 'secondary';
        }
    }

    renderParams(params) {
        if (!params || typeof params !== 'object') {
            return <span style={{ color: '#999', fontSize: '12px' }}>-</span>;
        }
        return (
            <div className="monitoramento-params">
                {Object.keys(params).map((key, i) => (
                    <div key={i}>
                        <strong>{key}</strong>: {String(params[key])}
                    </div>
                ))}
            </div>
        );
    }

    renderStatsCards() {
        const { stats, loading } = this.props;

        if (loading && !stats) {
            return (
                <div className="row mb-3">
                    {[0,1,2,3].map(i => (
                        <div className="col-md-3" key={i}>
                            <div className="card monitoramento-loading-card">
                                <span className="fa fa-refresh fa-spin"></span>
                            </div>
                        </div>
                    ))}
                </div>
            );
        }

        if (!stats) {
            return (
                <div className="row mb-3">
                    {[0,1,2,3].map(i => (
                        <div className="col-md-3" key={i}>
                            <div className="card monitoramento-card">
                                <h4>-</h4>
                                <p>{['Total de Logs', 'Warnings', 'Campanhas Afetadas', 'Logs Info'][i]}</p>
                            </div>
                        </div>
                    ))}
                </div>
            );
        }

        const warningCount = (stats.by_level && stats.by_level.warning) || 0;
        const infoCount = (stats.by_level && stats.by_level.info) || 0;
        const campaignCount = stats.by_campaign ? Object.keys(stats.by_campaign).length : 0;

        return (
            <div className="row mb-3">
                <div className="col-md-3">
                    <div className="card monitoramento-card">
                        <h4>{stats.total}</h4>
                        <p>Total de Logs</p>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card monitoramento-card warning">
                        <h4>{warningCount}</h4>
                        <p>Warnings (SEM user_painel_id)</p>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card monitoramento-card info">
                        <h4>{campaignCount}</h4>
                        <p>Campanhas Afetadas</p>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card monitoramento-card success">
                        <h4>{infoCount}</h4>
                        <p>Logs Info</p>
                    </div>
                </div>
            </div>
        );
    }

    renderCharts() {
        const { stats, loading } = this.props;

        if (loading && !stats) {
            return (
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="card monitoramento-loading-card">
                            <span className="fa fa-refresh fa-spin"></span>
                            <p>Carregando gráficos...</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card monitoramento-loading-card">
                            <span className="fa fa-refresh fa-spin"></span>
                        </div>
                    </div>
                </div>
            );
        }

        if (!stats) {
            return (
                <div className="row mb-3">
                    <div className="col-md-12">
                        <div className="card monitoramento-empty-state">
                            <i className="material-icons">assessment</i>
                            <p>Nenhum dado disponível para exibir gráficos</p>
                        </div>
                    </div>
                </div>
            );
        }

        // Gráfico por hora
        const hours = [];
        const hourCounts = [];
        for (let i = 0; i < 24; i++) {
            const h = String(i).padStart(2, '0');
            hours.push(h + ':00');
            hourCounts.push((stats.by_hour && stats.by_hour[h]) || 0);
        }

        const hourData = {
            labels: hours,
            datasets: [{
                label: 'Logs por Hora',
                data: hourCounts,
                backgroundColor: 'rgba(33, 150, 243, 0.6)',
                borderColor: 'rgba(33, 150, 243, 1)',
                borderWidth: 1
            }]
        };

        // Gráfico por campanha (top 10)
        const campaigns = stats.by_campaign ? Object.entries(stats.by_campaign).slice(0, 10) : [];
        const campaignData = {
            labels: campaigns.map(c => 'Camp. ' + c[0]),
            datasets: [{
                label: 'Logs por Campanha',
                data: campaigns.map(c => c[1]),
                backgroundColor: 'rgba(255, 152, 0, 0.6)',
                borderColor: 'rgba(255, 152, 0, 1)',
                borderWidth: 1
            }]
        };

        // Gráfico por action
        const actions = stats.by_action ? Object.entries(stats.by_action) : [];
        const actionData = {
            labels: actions.map(a => a[0]),
            datasets: [{
                label: 'Logs por Action',
                data: actions.map(a => a[1]),
                backgroundColor: ['rgba(76, 175, 80, 0.6)', 'rgba(244, 67, 54, 0.6)', 'rgba(156, 39, 176, 0.6)', 'rgba(0, 188, 212, 0.6)'],
                borderWidth: 1
            }]
        };

        const chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            scales: { yAxes: [{ ticks: { beginAtZero: true } }] },
            legend: { display: false }
        };

        return (
            <div className="row mb-3">
                <div className="col-md-6">
                    <div className="card monitoramento-chart">
                        <h6>Volume por Hora</h6>
                        <div className="monitoramento-chart-container">
                            <Bar data={hourData} options={chartOptions} />
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card monitoramento-chart">
                        <h6>Top Campanhas</h6>
                        <div className="monitoramento-chart-container">
                            <Bar data={campaignData} options={{ ...chartOptions, scales: { ...chartOptions.scales, xAxes: [{ ticks: { fontSize: 10 } }] } }} />
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card monitoramento-chart">
                        <h6>Por Action</h6>
                        <div className="monitoramento-chart-container">
                            <Bar data={actionData} options={chartOptions} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderExpandedRow = (row) => {
        return (
            <div className="monitoramento-expanded">
                <div className="row">
                    <div className="col-md-6">
                        <h6>Detalhes do Log</h6>
                        <table className="table table-sm table-bordered">
                            <tbody>
                                <tr><td className="detail-label"><strong>Timestamp</strong></td><td>{row.timestamp}</td></tr>
                                <tr><td><strong>Module/Action</strong></td><td>{row.module}/{row.action}</td></tr>
                                <tr><td><strong>Level</strong></td><td>{row.level}</td></tr>
                                <tr><td><strong>Campaign ID</strong></td><td>{row.campaign_id || '-'}</td></tr>
                                <tr><td><strong>Painel ID</strong></td><td>{row.painel_id || '-'}</td></tr>
                                <tr><td><strong>IP</strong></td><td>{row.ip || '-'}</td></tr>
                                <tr><td><strong>User Agent</strong></td><td style={{wordBreak:'break-all'}}>{row.user_agent || '-'}</td></tr>
                                <tr><td><strong>User Painel ID</strong></td><td>{row.user_painel_id || '-'}</td></tr>
                                <tr><td><strong>Status</strong></td><td>{row.status || '-'}</td></tr>
                                <tr><td><strong>Method</strong></td><td>{row.method || '-'}</td></tr>
                                {row.has_pixel && <tr><td><strong>Has Pixel</strong></td><td>{row.has_pixel}</td></tr>}
                                {row.hash && <tr><td><strong>Hash</strong></td><td>{row.hash}</td></tr>}
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-6">
                        {row.get_params && typeof row.get_params === 'object' && (
                            <div>
                                <h6>GET Query Params</h6>
                                <table className="table table-sm table-bordered">
                                    <thead><tr><th>Param</th><th>Valor</th></tr></thead>
                                    <tbody>
                                        {Object.entries(row.get_params).map(([key, val], i) => (
                                            <tr key={i}>
                                                <td><strong>{key}</strong></td>
                                                <td style={{wordBreak:'break-all'}}>{typeof val === 'object' ? JSON.stringify(val) : String(val)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {row.post_params && typeof row.post_params === 'object' && (
                            <div>
                                <h6>POST Params</h6>
                                <table className="table table-sm table-bordered">
                                    <thead><tr><th>Param</th><th>Valor</th></tr></thead>
                                    <tbody>
                                        {Object.entries(row.post_params).map(([key, val], i) => (
                                            <tr key={i}>
                                                <td><strong>{key}</strong></td>
                                                <td style={{wordBreak:'break-all'}}>{typeof val === 'object' ? JSON.stringify(val) : String(val)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {row.alternatives && (
                            <div>
                                <h6>Alternatives</h6>
                                <pre className="monitoramento-raw-log" style={{ maxHeight: '150px' }}>
                                    {JSON.stringify(row.alternatives, null, 2)}
                                </pre>
                            </div>
                        )}
                        <div>
                            <h6>Raw Log</h6>
                            <pre className="monitoramento-raw-log">
                                {row.raw}
                            </pre>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { logs, pagination, loading } = this.props;
        const { filters, autoRefresh } = this.state;
        const currentPage = parseInt(pagination.page, 10) || 1;
        const totalPages = parseInt(pagination.total_pages, 10) || 1;

        return (
            <div>
                <Header />

                <div className="alert alert-dark m-0 p-0">
                    <div className="container p-0">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item active">
                                <a href="#">{translate('Monitoramento')}</a>
                            </li>
                        </ol>
                    </div>
                </div>

                <div className="container">
                    <div className="row pt-4 mb-3">
                        <div className="col-md-8">
                            <h3 className="pl-0">
                                <strong>
                                    <i className="material-icons" style={{ verticalAlign: 'middle', marginRight: '8px' }}>assessment</i>
                                    {translate('Monitoramento de Surveys')}
                                </strong>
                            </h3>
                            <p style={{ color: '#666', fontSize: '14px' }}>
                                Logs de implementação e rastreamento de pesquisas
                            </p>
                        </div>
                        <div className="col-md-4 text-right" style={{ paddingTop: '20px' }}>
                            <button
                                className={`btn btn-sm ${autoRefresh ? 'btn-danger' : 'btn-success'} btn-round`}
                                onClick={this.toggleAutoRefresh}
                            >
                                <i className="material-icons" style={{ fontSize: '14px', verticalAlign: 'middle' }}>
                                    {autoRefresh ? 'pause' : 'play_arrow'}
                                </i>
                                {autoRefresh ? ' Auto-refresh ON (15s)' : ' Auto-refresh'}
                            </button>
                            <button
                                className="btn btn-sm btn-success btn-round"
                                onClick={this.fetchData}
                                disabled={loading}
                            >
                                <i className="material-icons" style={{ fontSize: '14px', verticalAlign: 'middle' }}>refresh</i>
                                {' '}{translate('Atualizar')}
                            </button>
                        </div>
                    </div>

                    {/* Filtros */}
                    <div className="card monitoramento-filters">
                        <form onSubmit={this.handleSearch}>
                            <div className="row">
                                <div className="col-md-3">
                                    <label>Data Início</label>
                                    <input type="date" className="form-control" value={filters.date_start}
                                        onChange={e => this.handleFilterChange('date_start', e.target.value)} />
                                </div>
                                <div className="col-md-3">
                                    <label>Data Fim</label>
                                    <input type="date" className="form-control" value={filters.date_end}
                                        onChange={e => this.handleFilterChange('date_end', e.target.value)} />
                                </div>
                                <div className="col-md-3">
                                    <label>Action</label>
                                    <select className="form-control" value={filters.action}
                                        onChange={e => this.handleFilterChange('action', e.target.value)}>
                                        <option value="">Todas</option>
                                        <option value="campaign">campaign</option>
                                        <option value="index">index</option>
                                        <option value="create">create</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label>Level</label>
                                    <select className="form-control" value={filters.level}
                                        onChange={e => this.handleFilterChange('level', e.target.value)}>
                                        <option value="">Todos</option>
                                        <option value="info">info</option>
                                        <option value="warning">warning</option>
                                        <option value="error">error</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label>Campaign ID</label>
                                    <input type="text" className="form-control" value={filters.campaign_id}
                                        placeholder="Ex: 4121"
                                        onChange={e => this.handleFilterChange('campaign_id', e.target.value)} />
                                </div>
                                <div className="col-md-3">
                                    <label>IP</label>
                                    <input type="text" className="form-control" value={filters.ip}
                                        placeholder="Ex: 186.249.229.153"
                                        onChange={e => this.handleFilterChange('ip', e.target.value)} />
                                </div>
                                <div className="col-md-3">
                                    <label>Busca</label>
                                    <input type="text" className="form-control" value={filters.search}
                                        placeholder="Busca livre..."
                                        onChange={e => this.handleFilterChange('search', e.target.value)} />
                                </div>
                                <div className="col-md-3 text-right" style={{ paddingTop: '25px' }}>
                                    <button type="submit" className="btn btn-sm btn-success btn-round" disabled={loading}>
                                        <i className="material-icons" style={{ fontSize: '14px', verticalAlign: 'middle' }}>search</i>
                                        {' '}Filtrar
                                    </button>
                                    <button type="button" className="btn btn-sm btn-secondary btn-round" onClick={() => {
                                        const today = new Date().toISOString().split('T')[0];
                                        this.setState({
                                            filters: { date_start: today, date_end: today, module: '', action: '', campaign_id: '', ip: '', level: '', search: '', page: 1, limit: 50 }
                                        }, this.fetchData);
                                    }}>
                                        Limpar
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

                    {/* Stats Cards */}
                    {this.renderStatsCards()}

                    {/* Charts */}
                    {this.renderCharts()}

                    {/* Tabela de Logs */}
                    <div className="card monitoramento-table-card">
                        <div className="monitoramento-table-header">
                            <h6>
                                Logs ({pagination.total} registros)
                                {loading && <span style={{ marginLeft: '10px', color: '#999' }}>Carregando...</span>}
                            </h6>
                            <div>
                                <span className="monitoramento-pagination-info">
                                    Página {currentPage} de {totalPages}
                                </span>
                            </div>
                        </div>

                        <DataTable
                            columns={this.columns}
                            data={logs || []}
                            noHeader
                            dense
                            highlightOnHover
                            pointerOnHover
                            expandableRows
                            expandableRowsComponent={<ExpandedComponent renderExpandedRow={this.renderExpandedRow} />}
                            progressPending={loading}
                            noDataComponent={<div style={{ padding: '20px', color: '#999' }}>Nenhum log encontrado para os filtros selecionados</div>}
                            customStyles={{
                                rows: { style: { fontSize: '12px', minHeight: '36px' } },
                                headCells: { style: { fontSize: '12px', fontWeight: 'bold', backgroundColor: '#f5f5f5' } },
                            }}
                        />

                        {/* Paginação */}
                        {totalPages > 1 && (
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                                <nav>
                                    <ul className="pagination">
                                        <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
                                            <button className="page-link" onClick={() => this.handlePageChange(currentPage - 1)}>Anterior</button>
                                        </li>
                                        {Array.from({ length: Math.min(totalPages, 10) }, (_, i) => {
                                            let pageNum;
                                            if (totalPages <= 10) {
                                                pageNum = i + 1;
                                            } else {
                                                const start = Math.max(1, Math.min(currentPage - 4, totalPages - 9));
                                                pageNum = start + i;
                                            }
                                            return (
                                                <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                                                    <button className="page-link" onClick={() => this.handlePageChange(pageNum)}>{pageNum}</button>
                                                </li>
                                            );
                                        })}
                                        <li className={`page-item ${currentPage >= totalPages ? 'disabled' : ''}`}>
                                            <button className="page-link" onClick={() => this.handlePageChange(currentPage + 1)}>Próximo</button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        )}
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

// Componente auxiliar para rows expandidas
class ExpandedComponent extends Component {
    render() {
        return this.props.renderExpandedRow(this.props.data);
    }
}

const mapStateToProps = store => ({
    logs: store.monitoramento.logs,
    pagination: store.monitoramento.pagination,
    stats: store.monitoramento.stats,
    loading: store.monitoramento.loading,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ getLogs, getStats, getDates }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Monitoramento);
